import { render, staticRenderFns } from "./IDVerificationSelect.vue?vue&type=template&id=af828c5e"
import script from "./IDVerificationSelect.vue?vue&type=script&lang=js"
export * from "./IDVerificationSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af828c5e')) {
      api.createRecord('af828c5e', component.options)
    } else {
      api.reload('af828c5e', component.options)
    }
    module.hot.accept("./IDVerificationSelect.vue?vue&type=template&id=af828c5e", function () {
      api.rerender('af828c5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/shared/components/user/IDVerificationSelect.vue"
export default component.exports